import { has, isArray, isObject, isString, kebabCase } from "lodash-es";

export const generateKey = (input: any): string | undefined => {
  switch (true) {
    case isString(input):
      return kebabCase(input) || undefined;

    case isArray(input) && input.every(isString):
      return input.join("-") || undefined;

    case isArray(input) &&
      input.every((item) => isObject(item) && has(item, "id")):
      return (
        input
          .map(({ id }) => id)
          .sort()
          .join("-") || undefined
      );

    case isObject(input) && has(input, "id"):
      return String(input.id) || undefined;

    default:
      return undefined;
  }
};
